import { PlatformUtility } from 'utility-ts-platform';
import { StudyGroupsCapabilityConfiguration } from '../../study_groups_configuration';
import { StudyGroupModalService } from '../study_groups_modal_service';

export class StudyGroupJoiningModalController {
  private isDesktop: boolean;
  private applyDesktopStyle?: true;
  private applyMobileStyle: boolean;

  constructor(
    private ngStudyGroupModalService: StudyGroupModalService,
    private ngStudyGroupsCapabilityConfiguration: StudyGroupsCapabilityConfiguration
  ) {}
  $onInit() {
    this.isDesktop = PlatformUtility.isDesktop();
    this.applyDesktopStyle = !this.ngStudyGroupsCapabilityConfiguration.config.isMobile || undefined;
    this.applyMobileStyle = this.ngStudyGroupsCapabilityConfiguration.config.isMobile;
  }
  confirm(): void {
    this.ngStudyGroupModalService.modelContent.confirmationCallBack();
  }
  closeModal(): void {
    this.ngStudyGroupModalService.hide();
  }
}

export class StudyGroupJoiningModalComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-study-groups/src/modals/study_group_joining_modal/study_group_joining_modal.html';
  public controller: any = StudyGroupJoiningModalController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/modals/study_group_joining_modal/study_group_joining_modal.ts